import { connect } from 'react-redux';

import PresentationComponent from '../../../components/dashboards/tabcomponents/TemplateDrawer';
import {
  createTemplate,
  deleteTemplate,
  resetTemplate,
  toggleTemplate,
  updateTemplate,
} from '../../../actions/dashboards/templates';
import {
  getFilteredTemplatesByType,
  getRetentionComplexDimensionType,
  getRetentionComplexFirstEvent,
  getRetentionComplexIdUsingTemplate,
  getRetentionComplexReturnEvent,
} from '../../../reducers/analyticsApp';
import { RETENTION_TEMPLATE_TYPE } from '../../../constants/dashboards';
import { setErrorMessage } from '../../../actions/application';
import { validation } from '../../../utils/dashboards';

const composeTemplateDescription = ({ firstEvent, returnEvent, dimensionType }) =>
  !!firstEvent && !!returnEvent ? `${firstEvent} to ${returnEvent} (${dimensionType})` : '';

const mapStateToProps = (state) => ({
  templates: getFilteredTemplatesByType(state, RETENTION_TEMPLATE_TYPE),
  idUsingTemplate: getRetentionComplexIdUsingTemplate(state),
  descriptionParams: {
    firstEvent: getRetentionComplexFirstEvent(state),
    returnEvent: getRetentionComplexReturnEvent(state),
    dimensionType: getRetentionComplexDimensionType(state),
  },
});

const mapDispatchToProps = {
  onReset: () => resetTemplate(RETENTION_TEMPLATE_TYPE),
  createTemplate: (templateName, templateDescription) =>
    createTemplate(templateName, templateDescription, RETENTION_TEMPLATE_TYPE),
  updateTemplate: (templateName, templateDescription) =>
    updateTemplate(templateName, templateDescription, RETENTION_TEMPLATE_TYPE),
  onToggle: (template) => toggleTemplate(template),
  setErrorMessage: (message) => setErrorMessage(message),
  onDelete: (id) => deleteTemplate(id),
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  composeDescription: (setDescription) => {
    setDescription(composeTemplateDescription(stateProps.descriptionParams));
  },
  onCreate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.createTemplate
    ),
  onUpdate: (templateName, templateDescription) =>
    validation(
      dispatchProps.setErrorMessage,
      templateName,
      templateDescription,
      dispatchProps.updateTemplate
    ),
});

const RetentionTemplateDrawer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PresentationComponent);

export default RetentionTemplateDrawer;
